import { AppDispatch, RootState } from "../../../../../ReduxToolkit/Store";
import { clearReduxMessages } from "../../../../../utils/reduxUtils/clearReduxMessages";
import { clearTeamMembersAttendanceApprovalError } from "../slice/teamMembersAttendanceApproveSlice";
import { clearBulkApprovedAttendanceError } from "../slice/teamMembersAttendanceBulkApproveSlice";
import { clearTeamMembersAttendanceListError } from "../slice/teamMembersAttendanceListSlice";

const clearAttendanceCorrectionStates = [
  clearTeamMembersAttendanceListError,
  clearBulkApprovedAttendanceError,
  clearTeamMembersAttendanceApprovalError,
];

export const selectTeamMembersAttendanceListLoading = (state: RootState) =>
  state.teamMembersAttendanceList.loading;

export const selectTeamMembersAttendanceList = (state: RootState) =>
  state.teamMembersAttendanceList.data;

export const selectTeamMembersAttendanceListError = (state: RootState) =>
  state.teamMembersAttendanceList.error;

export const selectTeamMembersAttendanceBulkApproveDetails = (
  state: RootState
) => state.teamMembersAttendanceBulkApprove.data;

export const selectTeamMembersAttendanceBulkApproveError = (state: RootState) =>
  state.teamMembersAttendanceBulkApprove.error;

export const selectTeamMembersAttendanceApproveDetails = (state: RootState) =>
  state.teamMembersAttendanceApprove.data;

export const selectTeamMembersAttendanceApproveError = (state: RootState) =>
  state.teamMembersAttendanceApprove.error;

export const selectTeamMembersFinancialYear = (state: RootState) =>
  state.financialYearSlice.teamMemberAttendance.selectedFinancialYear;

export const clearEmployeesAttendanceCorrectionStates=  (dispatch:AppDispatch) => clearReduxMessages(dispatch,clearAttendanceCorrectionStates)